<template>
  <div class="food-navbar">
    <link
      href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet"
    >
    <template v-if="!source">
      <router-link
        :to="{name: 'food-search'}"
        class="item"
        :class="[current == 'food-search' ? 'on' : '']"
      >
        Food Search
      </router-link>
      <router-link
        :to="{name: 'food-groups'}"
        class="item"
        :class="[current == 'food-groups' ? 'on' : '']"
      >
        Food Groups
      </router-link>
      <router-link
        :to="{name: 'my-favorites'}"
        class="item"
        :class="[current == 'my-favorites' ? 'on' : '']"
      >
        My Favorites
      </router-link>
      <router-link
        :to="{name: 'recipe-maker'}"
        class="item"
        :class="[current == 'recipe-maker' ? 'on' : '']"
      >
        Recipe Maker
      </router-link>
      <router-link
        :to="{name: 'my-recipes'}"
        class="item"
        :class="[current == 'my-recipes' ? 'on' : '']"
      >
        My Recipes
      </router-link>
      <router-link
        :to="{name: 'fff-recipes'}"
        class="item"
        :class="[current == 'fff-recipes' ? 'on' : '']"
      >
        FFF Recipes
      </router-link>
    </template>
    <template v-if="source == 'tracker'">
      <router-link
        :to="{name: 'meal-entries'}"
        class="item"
        :class="[current == 'meal-entries' ? 'on' : '']"
      >
        Meal Entries
      </router-link>
      <router-link
        :to="{name: 'food-insights'}"
        class="item"
        :class="[current == 'food-insights' ? 'on' : '']"
      >
        Daily Intake
      </router-link>
      <router-link
        :to="{name: 'progress-reports'}"
        class="item"
        :class="[current == 'progress-reports' ? 'on' : '']"
      >
        Progress Reports
      </router-link>
    </template>
    <template v-if="source == 'share_portal'">
      <router-link
        :to="{name: 'share-portal-profile'}"
        class="item"
        :class="[current == 'share-portal-profile' ? 'on' : '']"
      >
        Profile
      </router-link>
      <router-link
        :to="{name: 'share-portal-meal-entries', query: {share: 1}}"
        class="item"
        :class="[current == 'meal-entries' ? 'on' : '']"
      >
        Meal Entries
      </router-link>
      <router-link
        :to="{name: 'share-portal-food-insights', query: {share: 1 }}"
        class="item"
        :class="[current == 'food-insights' ? 'on' : '']"
      >
        Daily Intake
      </router-link>
      <router-link
        :to="{name: 'share-portal-progress-reports', query: {share: 1}}"
        class="item"
        :class="[current == 'progress-reports' ? 'on' : '']"
      >
        Progress Reports
      </router-link>
    </template>
    <router-link
      v-if="usertype=='Guest'"
      :to="{ name: 'login' }"
      class="item"
    >
      <span @click="logout">Logout</span>
    </router-link>
  </div>
</template>



<script>
export default {
  props: ['current', 'source'],
  data() {
    return {
      usertype:''
    }
  },
  mounted(){
    this.check_user();
  },
  methods: {
    async check_user(){
      let checkuser = await this.$http('/api/share-portal/usertype',{
        method:"get",
      }).then(response => response.json())
        .then(async function(json) {
          if(json.message == "Unauthenticated."){
            throw new Error(JSON.stringify(json));
          }else{
            return json;
          }
        });

      if(checkuser.type=="Guest"){
        this.usertype = "Guest";
      }
      if(checkuser.type=="User"){
        this.usertype = "User";
      }
    },
    async logout(){
      let addbs = await this.$http('/api/share-portal/reports/logout',{
        method:"get",
      }).then(response => response.json())
        .then(async (json) => {
          await this.$store.dispatch('user/setLoggedOut');

          window.location="/login";
        });
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
